export default "/institutions/cresol.svg";